import { render, staticRenderFns } from "./price_item_list.vue?vue&type=template&id=60b52fb4&"
import script from "./price_item_list.vue?vue&type=script&lang=js&"
export * from "./price_item_list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports